import React from "react";
import { Redirect } from "react-router-dom";

function Home(): JSX.Element {
  return <Redirect to="/orders" />
}

export default Home;
